// extracted by mini-css-extract-plugin
module.exports = {"search-bar":"style_search-bar__25jT0"};